import { useCallback, useEffect, useRef, useState } from 'react';

const MAX_HEIGHT = 42;
const MORE_LABEL = 'Показать еще';
const LESS_LABEL = 'Скрыть';

export default function ExpandableText({ text, className }) {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const [truncatedText, setTruncatedText] = useState('');
  const [ready, setReady] = useState(false);

  const containerRef = useRef(null);
  const measureRef = useRef(null);

  const tailText = useCallback(() => {
    const glueLabel = MORE_LABEL.replace(/ /g, '\u00A0');
    return `… ${glueLabel}`;
  }, []);

  const measure = useCallback(() => {
    const container = containerRef.current;
    const measureNode = measureRef.current;
    if (!container || !measureNode) return;

    measureNode.style.width = `${container.clientWidth}px`;
    measureNode.textContent = text;
    const fullHeight = measureNode.scrollHeight;

    if (fullHeight <= MAX_HEIGHT + 1) {
      setIsTruncated(false);
      setReady(true);
      return;
    }

    const tail = tailText();
    let low = 0;
    let high = text.length;
    let best = '';

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      measureNode.textContent = `${text.slice(0, mid).trimEnd()}${tail}`;
      if (measureNode.scrollHeight <= MAX_HEIGHT + 1) {
        best = text.slice(0, mid).trimEnd();
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    setIsTruncated(true);
    setTruncatedText(best);
    setReady(true);
  }, [text, tailText]);

  useEffect(() => {
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setExpanded(false);
    measure();
  }, [text]);

  const toggle = useCallback((e) => {
    e.preventDefault();
    setExpanded((prev) => !prev);
  }, []);

  const showFull = expanded || !isTruncated || !ready;

  return (
    <div className={className} ref={containerRef}>
      <span
        ref={measureRef}
        className={className}
        style={{ position: 'fixed', top: -9999, left: -9999, visibility: 'hidden', whiteSpace: 'normal' }}
      />
      {showFull ? (
        <>
          {text}
          {isTruncated && (
            <>
              {' '}
              <a href='#' className='card__tag-toggle' onClick={toggle}>
                {LESS_LABEL}
              </a>
            </>
          )}
        </>
      ) : (
        <>
          {truncatedText}
          {'… '}
          <a href='#' className='card__tag-toggle' onClick={toggle}>
            {MORE_LABEL.replace(/ /g, '\u00A0')}
          </a>
        </>
      )}
    </div>
  );
}
